/* Demo stub — brak połączenia z API */
import { createNamedStub, createServiceStub } from "../../demo/stubHelpers";
import { getMockProductsPage } from "../../demo/mockProducts";
import {
  changeMockProductState,
  getMockProductDetail,
  getMockProductStatistics,
  mockProductMutationSuccess,
} from "../../demo/mockProductDetails";

const productServices = {
  ...createServiceStub(),
  getFiltered: async (pageInfo: any) => getMockProductsPage(pageInfo),
  get: createNamedStub({}),
  getDetailById: getMockProductDetail,
  getStatistics: getMockProductStatistics,
  changeState: changeMockProductState,
  addPhotoFiles: mockProductMutationSuccess,
  removePhotoFile: mockProductMutationSuccess,
  addAdditionalFile: mockProductMutationSuccess,
  removeAdditionalFile: mockProductMutationSuccess,
  add: mockProductMutationSuccess,
  update: mockProductMutationSuccess,
  remove: mockProductMutationSuccess,
};

export default productServices;
